module.exports = __webpack_public_path__ + "img/enemy_112_002.d8477e0e.png";